import { render, staticRenderFns } from "./why.vue?vue&type=template&id=0ae990ac"
import script from "./why.vue?vue&type=script&lang=js"
export * from "./why.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports